export default __webpack_public_path__ + "static/media/Otro.cfa2c123.svg";